import $ = require("jquery");
import { IWorkflowGraph, IGraphNodeWithEdges, IGraphEdgeDto } from "../models/iWorkFlow";

export function RenderWorkflowTextAlt(wfg: IWorkflowGraph, renderHistory: boolean) {
    let ol = $("<ol></ol>").attr("aria-label", wfg.Title);
    wfg.Nodes.forEach((nodeItem: IGraphNodeWithEdges, index) => {
        let nodeLi = $(`<li></li>`);
        let nodeLabel = renderHistory ? `${nodeItem.Label}${nodeItem.IsCurrent ? " [Current Phase]" : (nodeItem.IsInHistory ? " [In Response History]" : "")}` : nodeItem.Label;
        if (nodeItem.Url) {
            let a = $(`<a href='${nodeItem.Url}'>${nodeLabel}</a>`);
            if (nodeItem.ToolTip) {
                a.attr("title", nodeItem.ToolTip);
            }
            nodeLi.append(a);
        } else {
            nodeLi.text(nodeLabel);
        }
        if (nodeItem.OutEdges.length > 0 || nodeItem.InEdges.length > 0) {
            let edgeContainer = $("<ul></ul>");
            if (nodeItem.OutEdges.length > 0) {
                let outContainer = $("<li>Routing Triggers from Phase:</li>");
                let edgeUl = $("<ul></ul>");
                nodeItem.OutEdges.forEach((edgeItem: IGraphEdgeDto, index) => {
                    let edgeLi = $("<li></li>");
                    let edgeLabel = renderHistory ? `${edgeItem.Label}${edgeItem.IsInHistory ? " [In Response History]" : ""}` : edgeItem.Label;
                    if (edgeItem.Url) {
                        let ea = $(`<a href='${edgeItem.Url}'>${edgeLabel}</a><p class='mb-0'>To phase: ${edgeItem.HeadNodeLabel}</p>`);
                        if (edgeItem.ToolTip) {
                            ea.attr("title", edgeItem.ToolTip);
                        }
                        edgeLi.append(ea);
                    } else {
                        edgeLi.text(`${edgeLabel}`);
                        edgeLi.append(`<p class='mb-0'>To phase: ${edgeItem.HeadNodeLabel}</p>`);
                    }
                    edgeUl.append(edgeLi);
                })
                outContainer.append(edgeUl);
                edgeContainer.append(outContainer);
            }
            if (nodeItem.InEdges.length > 0) {
                let outContainer = $("<li>Routing Triggers to Phase:</li>");
                let edgeUl = $("<ul></ul>");
                nodeItem.InEdges.forEach((edgeItem: IGraphEdgeDto, index) => {
                    let edgeLi = $("<li></li>");
                    let edgeLabel = renderHistory ? `${edgeItem.Label}${edgeItem.IsInHistory ? " [In Response History]" : ""}` : edgeItem.Label;
                    if (edgeItem.Url) {
                        let ea = $(`<a href='${edgeItem.Url}'>${edgeLabel}</a><p class='mb-0'>From phase: ${edgeItem.TailNodeLabel}</p>`);
                        if (edgeItem.ToolTip) {
                            ea.attr("title", edgeItem.ToolTip);
                        }
                        edgeLi.append(ea);
                    } else {
                        edgeLi.text(`${edgeLabel}`);
                        edgeLi.append(`<p class='mb-0' > From phase: ${ edgeItem.TailNodeLabel } </p>`);
                    }
                    edgeUl.append(edgeLi);
                })
                outContainer.append(edgeUl);
                edgeContainer.append(outContainer);
            }
            nodeLi.append(edgeContainer);
        }
        ol.append(nodeLi);
    });
    return ol;
}